module.exports = __webpack_public_path__ + "static/media/meeting.97f0fbe1.jpg";